"use client";

import Image from "next/image";
import Link from "next/link";
import { useActionState, useEffect } from "react";
import { toast } from "sonner";

import { SubmitButton } from "@/components/submit-button";

import {
  requestPasswordReset,
  type RequestPasswordResetActionState,
} from "../actions";

export default function ForgotPassword() {
  const [state, formAction] = useActionState<
    RequestPasswordResetActionState,
    FormData
  >(requestPasswordReset, { status: "idle" });

  useEffect(() => {
    if (state.status === "success") {
      toast.success("E-Mail zum Zurücksetzen des Passworts wurde gesendet");
    } else if (state.status === "user_not_found") {
      toast.error("Kein Benutzer mit dieser E-Mail-Adresse gefunden");
    } else if (state.status === "error") {
      toast.error("Etwas ist schief gelaufen");
    }
  }, [state]);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gray-50">
      <div className="z-10 w-full max-w-md overflow-hidden rounded-2xl border border-gray-100 shadow-xl">
        <div className="flex flex-col items-center justify-center space-y-3 border-b border-gray-200 bg-white px-4 py-6 pt-8 text-center sm:px-16">
          <Image
            src="/img/drtimmerluibrand.png"
            alt="DGP Plattform Logo"
            className="h-12 invert object-contain mb-4"
            width={258}
            height={48}
            priority={true}
          />
          <h3 className="text-xl font-semibold">Passwort zurücksetzen</h3>
          <p className="text-sm text-gray-500">
            Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen
            des Passworts zu erhalten.
          </p>
        </div>
        {state.status === "success" ? (
          <div className="bg-gray-50 px-4 py-8 sm:px-16">
            <p className="text-center text-sm text-gray-600 mb-4">
              Eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts wurde
              an Ihre E-Mail-Adresse gesendet.
            </p>
            <p className="text-center text-sm text-gray-600">
              <Link href="/login" className="font-semibold text-gray-800">
                Zurück zum Login
              </Link>
            </p>
          </div>
        ) : (
          <form
            action={formAction}
            className="flex flex-col space-y-4 bg-gray-50 px-4 py-8 sm:px-16"
          >
            <div>
              <label
                htmlFor="email"
                className="block text-xs text-gray-600 uppercase"
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="user@acme.com"
                autoComplete="email"
                required
                className="mt-1 block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder:text-gray-400 shadow-sm focus:border-black focus:outline-none focus:ring-black sm:text-sm"
              />
            </div>
            <SubmitButton className="bg-white text-black hover:bg-gray-50">
              E-Mail senden
            </SubmitButton>
            <p className="text-center text-sm text-gray-600">
              <Link href="/login" className="font-semibold text-gray-800">
                Zurück zum Login
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
